<template>
  <div id="Register">
    <Head />
    <Login v-if="isLogin" @LoginOpen="openL" />
    <div class="register">
      <div class="rNav">
        <div :class="{ active: nav == 0 }" @click="rNav(0)">企业(单位)注册</div>
        <div :class="{ active: nav == 1 }" @click="rNav(1)">个人注册</div>
      </div>
      <div class="rMain" v-show="nav == 1">
        <div>
          <span style="margin-right:.3rem">省份/央企:</span>
          <div>
            <select @change="getEjgs($event)" v-model="companyID[0].Company">
              <option value>请选择省份/央企</option>
              <option v-for="(item, i) in yjgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            *
          </div>
        </div>
        <div>
          <span>隶属关系:</span>
          <div>
            <!-- <select @change="getEjgs($event)" v-model="form.yjgs">
              <option value>请选择一级公司</option>
              <option v-for="(item,i) in yjgs" :key="i" :value="item.Name">{{item.Name}}</option>
            </select>-->
            <select
              @change="getSjgs($event)"
              v-model="companyID[1].Company"
              :disabled="ejgs.length > 0 ? false : true"
            >
              <option value>请选择一级公司</option>
              <option v-for="(item, i) in ejgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <select
              @change="getSijgs($event)"
              v-model="companyID[2].Company"
              :disabled="sjgs.length > 0 ? false : true"
            >
              <option value>请选择二级公司</option>
              <option v-for="(item, i) in sjgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <select
              @change="getWjgs($event)"
              v-model="companyID[3].Company"
              :disabled="sijgs.length > 0 ? false : true"
            >
              <option value>请选择三级公司</option>
              <option v-for="(item, i) in sijgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <select
              @change="getLjgs($event)"
              v-model="companyID[4].Company"
              :disabled="wjgs.length > 0 ? false : true"
            >
              <option value>请选择四级公司</option>
              <option v-for="(item, i) in wjgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            *
          </div>
        </div>
        <div>
          <span>
            地
            <span></span>址:
          </span>
          <div>
            <select @change="getshi" v-model="address.province">
              <option value>请选择省份</option>
              <option
                v-for="(item, i) in province"
                :key="i"
                :value="item.name"
                >{{ item.name }}</option
              >
            </select>
            <select
              @change="getqu"
              v-model="address.city"
              :disabled="city.length > 0 ? false : true"
            >
              <option value>请选择市</option>
              <option v-for="(item, i) in city" :key="i">{{
                item.name
              }}</option>
            </select>
            <select
              @change="getqus"
              v-show="district"
              v-model="address.district"
              :disabled="district.length > 0 ? false : true"
            >
              <option value>请选择区</option>
              <option
                v-for="(item, i) in district"
                :key="i"
                :value="item.name"
                >{{ item.name }}</option
              >
            </select>
            *
          </div>
        </div>
        <div>
          <span>
            姓
            <span></span>名:
          </span>
          <div>
            <input
              type="text"
              placeholder="请输入您的姓名"
              v-model="userMsg.Realname"
            />*
          </div>
        </div>
        <div>
          <span>
            密
            <span></span>码:
          </span>
          <div>
            <input
              type="password"
              v-model="userMsg.Pwd"
              placeholder="请输入您的密码"
            />*
          </div>
        </div>
        <div>
          <span>确认密码:</span>
          <div>
            <input
              type="password"
              v-model="userMsg.Pwd1"
              placeholder="请再次输入您的密码"
            />*
          </div>
          <p class="verify" v-if="!(userMsg.Pwd === userMsg.Pwd1)">
            两次输入密码不一致
          </p>
        </div>
        <div>
          <span>所在部门:</span>
          <div>
            <input
              type="text"
              v-model="userMsg.Department"
              placeholder="请填写您所在的部门"
            />*
          </div>
        </div>
        <div>
          <span>
            职
            <span></span>务:
          </span>
          <div>
            <input
              type="text"
              v-model="userMsg.Position"
              placeholder="请填写您的职务"
            />
            *
          </div>
        </div>
        <div>
          <span>电子邮箱:</span>
          <div>
            <input
              @blur="mailbox"
              type="text"
              v-model="userMsg.Email"
              placeholder="请填写您的电子邮箱"
            />
            *
          </div>
          <p class="verify" v-if="yxgs == 1">电子邮箱格式不正确</p>
        </div>
        <div>
          <span style="padding-left:.2rem">手机号:</span>
          <div>
            <input
              type="text"
              @blur="phoneGs"
              v-model="userMsg.Phone"
              placeholder="请输入您的有效手机号作为登录账号"
            />
            *
          </div>
          <p class="verify" v-if="verify == 1">手机格式不正确</p>
        </div>

        <!-- <div>
          <span>所在部门</span>
          <div>
            <input type="text" placeholder="请填写您所的的部门" />*
          </div>
        </div>
        <div>
          <span>职务</span>
          <div>
            <input type="text" placeholder="请填写您的职务" />*
          </div>
        </div>
        <div>
          <span>电子邮箱</span>
          <div>
            <input type="text" placeholder="请输入您的电子邮箱" />*
          </div>
        </div>-->
        <div>
          <span style="padding-left:.2rem">验证码:</span>
          <div>
            <div>
              <input type="text" style="width:2.5rem" v-model="userMsg.yzm" />
              <button
                :class="btnDisabled ? 'btn2' : 'btn'"
                style="margin-left:.5rem"
                @click="sendMessage()"
                :disabled="btnDisabled"
              >
                {{ btnText }}
              </button>
              <!-- <button
                :class="btnDisabled?'btn2':'btn'"
                style="margin-left:.5rem"
              
              >{{btnText}}</button>-->
              <!-- <div class="btn" style="margin-left:.5rem" @click="getyzm(1)">获取短信验证码</div> -->
            </div>
            *
          </div>
        </div>
        <div class="fBtn">
          <div class="btn" @click="addUser">注册</div>
          <div class="btn btn1" @click="openLogin">登录</div>
        </div>
      </div>
      <div class="rMain" style="  position: relative;" v-show="nav == 0">
        <!-- <el-form-item label="验证码" :required="true">
            <el-input v-mode="sizeForm.yzm"></el-input>
        </el-form-item>-->
      </div>
      <div class="rMain" v-show="nav == 0">
        <div>
          <span class="firmSpan">省份/央企:</span>
          <div>
            <select @change="getEjgs($event)" v-model="companyID[0].Company">
              <option value>请选择省份/央企</option>
              <option v-for="(item, i) in yjgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            *
          </div>
        </div>
        <div>
          <span class="firmSpan">隶属关系:</span>
          <div>
            <select
              @change="getSjgs($event)"
              v-model="companyID[1].Company"
              :disabled="ejgs.length > 0 ? false : true"
            >
              <option value>请选择一级公司</option>
              <option v-for="(item, i) in ejgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <select
              @change="getSijgs($event)"
              v-model="companyID[2].Company"
              :disabled="sjgs.length > 0 ? false : true"
            >
              <option value>请选择二级公司</option>
              <option v-for="(item, i) in sjgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <select
              @change="getWjgs($event)"
              v-model="companyID[3].Company"
              :disabled="sijgs.length > 0 ? false : true"
            >
              <option value>请选择三级公司</option>
              <option v-for="(item, i) in sijgs" :key="i" :value="item.ID">{{
                item.Name
              }}</option>
            </select>
            <!-- <select v-model="form.sijgs" :disabled="sijgs.length>0?false:true">
                <option value>请选择四级公司</option>
                <option v-for="(item,i) in sijgs" :key="i" :value="item.Name">{{item.Name}}</option>
            </select>-->
            *
          </div>
        </div>

        <div>
          <span class="firmSpan">单位名称:</span>
          <div>
            <input placeholder="请输入单位的全称" v-model="company.Name" />*
          </div>
        </div>
        <div>
          <span class="firmSpan">
            地
            <span></span>址:
          </span>
          <div>
            <select @change="getshi($event)" v-model="address.province">
              <option value>请选择省份</option>
              <option
                v-for="(item, i) in province"
                :key="i"
                :value="item.name"
                >{{ item.name }}</option
              >
            </select>
            <select
              @change="getqu($event)"
              v-model="address.city"
              :disabled="city.length > 0 ? false : true"
            >
              <option value>请选择市</option>
              <option v-for="(item, j) in city" :key="j">{{
                item.name
              }}</option>
            </select>
            <select
              @change="getqus($event)"
              v-model="address.district"
              :disabled="district.length > 0 ? false : true"
            >
              <option value>请选择区</option>
              <option
                v-for="(item, a) in district"
                :key="a"
                :value="item.name"
                >{{ item.name }}</option
              >
            </select>
            *
          </div>
        </div>
        <div style="align-items:flex-start;">
          <span class="firmSpan">企业类型:</span>
          <div>
            <el-radio-group
              v-model="company.Property"
              style="display:block ;width:8rem"
            >
              <el-radio
                style="margin-bottoom:.3rem"
                v-for="(item, i) in propertyList"
                :key="i"
                :label="item.code"
                >{{ item.codename }}</el-radio
              > </el-radio-group
            >*
          </div>
        </div>
        <div style="width:10rem">
          <span class="firmSpan">统一信用代码:</span>
          <div>
            <input
              type="text"
              maxlength="18"
              @blur="yzgs"
              v-model="company.Code"
              placeholder="请填写您的企业统一信用代码"
            />
            *
            <p v-if="xinyong">统一信用代码格式不正确</p>
          </div>
        </div>
        <div style="align-items:flex-start;">
          <span class="firmSpan">营业执照:</span>
          <div>
            <div style="align-items:flex-start;width:6.8rem;">
              <div
                class="yyzz"
                v-loading="loading"
                element-loading-text="图片上传中"
              >
                <img v-if="company.Image" :src="company.Image" class="avatar" />
                <p style="color:#B8B8B8;margin:.1rem 0 0 .2rem" v-else>
                  上传营业执照
                </p>
              </div>
              <div @click="uploadImg" class="btn btnmini">上传</div>
              *
            </div>
          </div>
        </div>
        <div>
          <span class="firmSpan">
            密
            <span></span>码:
          </span>
          <div>
            <input
              type="password"
              v-model="company.Pwd"
              placeholder="请输入您的密码"
            />*
          </div>
        </div>
        <div style="width:10rem">
          <span class="firmSpan">确认密码:</span>
          <div>
            <input
              type="password"
              v-model="company.Pwd1"
              placeholder="请再次确认您的密码"
            />*
            <p class="verify" v-if="!(company.Pwd === company.Pwd1)">
              两次输入密码不一致
            </p>
          </div>
        </div>
        <div>
          <span class="firmSpan">联系人:</span>
          <div>
            <input
              type="text"
              v-model="company.Manager"
              placeholder="请输入您的企业联系人姓名"
            />*
          </div>
        </div>
        <div>
          <span class="firmSpan">所在部门:</span>
          <div>
            <input
              type="text"
              v-model="company.Department"
              placeholder="请填写您所在的部门"
            />*
          </div>
        </div>
        <div>
          <span class="firmSpan">
            职
            <span></span>务:
          </span>
          <div>
            <input
              type="text"
              v-model="company.Position"
              placeholder="请填写您的职务"
            />*
          </div>
        </div>
        <div style="width:10rem">
          <span class="firmSpan">电子邮箱:</span>
          <div>
            <input
              @blur="mailbox(1)"
              type="text"
              v-model="company.Email"
              placeholder="请填写联系人的电子邮箱"
            />
            *
            <p class="verify" v-if="yxgs1 == 2">电子邮箱格式不正确</p>
          </div>
        </div>
        <div>
          <span class="firmSpan">手机号:</span>
          <div>
            <div>
              <input
                type="text"
                @blur="phoneGs(1)"
                v-model="company.Phone"
                placeholder="请输入联系人的有效手机号作为登录账号"
              />
            </div>
            *
            <p class="verify" v-if="verify1 == 2">手机格式不正确</p>
          </div>
        </div>
        <div>
          <span class="firmSpan">验证码：</span>
          <div>
            <div>
              <input type="text" style="width:2.5rem" v-model="company.yzm" />
              <button
                :class="btnDisabled1 ? 'btn2' : 'btn'"
                style="margin-left:.5rem"
                :disabled="btnDisabled1"
                @click="sendMessage1()"
              >
                {{ btnText1 }}
              </button>
              <!-- <button
                :class="btnDisabled1?'btn2':'btn'"
                style="margin-left:.5rem"
               
              >{{btnText1}}</button>-->
              <!-- <div class="btn" style="margin-left:.5rem">获取短信验证码</div> -->
            </div>
            *
          </div>
        </div>
        <!-- <div>
          <span>统一代码</span>
          <div>
            <input type="text" placeholder="请输入您的企业统一代码" />*
          </div>
        </div>
        <div class="textarea">
          <span>营业执照</span>
          <div>
            <div>
              <img :src="company.Image" alt />
              <div class="imgUp">上传</div>
            </div>*
          </div>
        </div>-->
        <div class="fBtn">
          <div class="btn" @click="addCompany">注册</div>
          <div class="btn" @click="openLogin">登录</div>
        </div>
      </div>
    </div>
    <el-upload
      ref="uploads"
      id="upload1"
      style="opacity:0;height:0;overflow:hidden;"
      class="avatar-uploader1"
      :http-request="upload"
      :auto-upload="false"
      action="upload1"
      :on-success="handleSuccess"
      :on-change="submitUpload"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      accept=".jpeg, .jpg, .png"
    >
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Login from "../components/Login";
import RightNav from "../components/RightNav";
export default {
  name: "Register",
  data() {
    return {
      s: 0,
      btnText: "获取短信验证码",
      btnText1: "获取短信验证码",
      btnDisabled: false,
      btnDisabled1: false,
      isLogin: false,
      loading: false,
      companyID: [
        { Company: "", Rank: "", Province: "" },
        { Company: "", Rank: "", Province: "" },
        { Company: "", Rank: "", Province: "" },
        { Company: "", Rank: "", Province: "" },
        { Company: "", Rank: "", Province: "" },
      ],
      form: {
        wjgs: "",
        yjgs: "",
        ejgs: "",
        sjgs: "",
        sijgs: "",
      },
      address: {
        province: "",
        city: "",
        district: "",
      },
      province: [],
      city: [],
      district: [],
      infoForm: {
        Image: "",
      },
      userMsg: {
        Realname: "",
        Pwd: "",
        Pwd1: "",
        Province: "",
        Company: "",
        // bm: "",
        Position: "",
        City: "",
        Email: "",
        Phone: "",
        Image:
          "http://39.100.116.249:92/upload/image/202004/20200403195326458.png",
        Department: "",
        Rank: "",
        yzm: "",
        Type: 1,
      },
      verify: false,
      verify1: false,
      yxgs1: false,
      yxgs: false,
      xinyong: false,
      radio: "",
      yjgs: [],
      ejgs: [],
      sjgs: [],
      sijgs: [],
      wjgs: [],
      nav: 0,
      val: "",
      iscompany: "",
      cityList: [],
      propertyList: [],
      options: [],
      haveName: 0,
      user: {
        Realname: "徐加春",
        SuperiorD: "32",
        Pwd: "123456",
        Pwd1: "123456",
        Phone: "1",
        Province: "10",
        Company: "32",
        Department: "1",
        Position: "项目部",
        City: "杭州",
        Email: "123@qq.com",
        Image: "1234556",
        Status: 0,
        Type: 1,
        Specificity: "0",
        introduction: "123",
      },
      company: {
        Name: "",
        SuperiorD: "",
        Pwd: "",
        Pwd1: "",
        Province: "",
        Property: "",
        City: "",
        Manager: "",
        Department: "",
        Position: "",
        Phone: "",
        Email: "",
        Code: "",
        Image: "",
        Stauts: 1,
        Rank: "",
        HeaderImg:
          "http://39.100.116.249:92/upload/image/202004/20200403195326458.png",
        // Rank: "",
        // Specificity: 0,
        yzm: "",
      },
    };
  },
  created() {
    this.getcity();
    this.getProperty();
    this.getchild();
    this.getchinaarea();
  },
  mounted() {},
  methods: {
    sendMessage() {
      let that = this;
      if (this.btnDisabled) {
        return;
      }
      if (!that.userMsg.Phone) {
        that.$message.error("手机号不能为空");
        return;
      } else {
        this.$axios
          .post(
            "sendmsg/send",
            that.$qs.stringify({
              Phone: that.userMsg.Phone,
              actions: "MsgUserReg",
            })
          )
          .then((res) => {
            if (res.data.code == 10000) {
              that.$message({
                message: "短信验证码已发送,请注意查收",
                type: "success",
              });
            } else {
              that.$message(res.data.msg);
            }
          });
      }
      this.getSecond(120);
    },
    //发送验证码
    getSecond(wait) {
      let _this = this;
      let _wait = wait;
      if (wait == 0) {
        this.btnDisabled = false;
        this.btnText = "获取短信验证码";
        wait = _wait;
      } else {
        this.btnDisabled = true;
        this.btnText = "验证码(" + wait + "s)";
        wait--;
        setTimeout(function() {
          _this.getSecond(wait);
        }, 1000);
      }
    },
    sendMessage1() {
      let that = this;
      if (!that.company.Phone) {
        that.$message.error("手机号不能为空");
        return;
      } else {
        this.$axios
          .post(
            "sendmsg/send",
            that.$qs.stringify({
              Phone: that.company.Phone,
              actions: "MsgComReg",
            })
          )
          .then((res) => {
            if (res.data.code == 10000) {
              that.$message({
                message: "短信验证码已发送,请注意查收",
                type: "success",
              });
            } else {
              that.$message(res.data.msg);
            }
          });
      }
      if (this.btnDisabled1) {
        return;
      }
      this.getSecond1(120);
    },
    getSecond1(wait) {
      let _this = this;
      let _wait = wait;

      if (wait == 0) {
        this.btnDisabled1 = false;
        this.btnText1 = "获取短信验证码";
        wait = _wait;
      } else {
        this.btnDisabled1 = true;
        this.btnText1 = "验证码(" + wait + "s)";
        wait--;
        setTimeout(function() {
          _this.getSecond1(wait);
        }, 1000);
      }
    },

    yzgs() {
      let reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
      // console.log(this.company.Code.length);
      this.xinyong = !reg.test(this.company.Code);
    },
    openL(e) {
      this.isLogin = e;
    },
    openLogin() {
      this.isLogin = true;
    },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传
    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是图片格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      return isJPG;
      // return isJPG && isLt2M;
      // return true;
    },
    upload(file) {
      let that = this;
      console.log(file);
      var formData = new FormData();
      console.log(file.file);
      formData.append("file", file.file);
      formData.append("upload_type", "image");
      console.log(formData);
      this.loading = true;
      that.$axios
        .post("upload/index?", formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            this.loading = false;
            this.company.Image = res.data.data;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message(res.data.msg);
          }
        });
      this.$refs.uploads.clearFiles();
    },
    uploadImg() {
      console.log(1);
      document.querySelector(".avatar-uploader1 input").click();
    },
    rNav(i) {
      this.nav = i;
      if (i == 1) {
        this.$alert("若无本单位信息,请联系本单位管理员注册", "温馨提示", {
          confirmButtonText: "确定",
          // callback: action => {
          //   this.$message({
          //     type: "info",
          //     message: `action: ${action}`
          //   });
          // }
        });
      }
    },
    mailbox(i) {
      let that = this;
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (i == 1) {
        if (!reg.test(that.company.Email)) {
          that.yxgs1 = 2;
        } else {
          that.yxgs1 = false;
        }
      } else {
        if (!reg.test(that.userMsg.Email)) {
          that.yxgs = 1;
        } else {
          that.yxgs = false;
        }
      }
    },
    phoneGs(i) {
      let that = this;
      let reg = /^1\d{10}$/;
      console.log(i);
      if (i == 1) {
        if (!reg.test(that.company.Phone)) {
          that.verify1 = 2;
        } else {
          that.verify1 = false;
        }
      } else {
        if (!reg.test(that.userMsg.Phone)) {
          that.verify = 1;
        } else {
          that.verify = false;
        }
      }
    },
    getchinaarea() {
      let that = this;
      this.$axios
        .post(
          "chinaarea/index",
          that.$qs.stringify({
            level: 1,
          })
        )
        .then((res) => {
          console.log(res.data.data, 1111111);
          if (res.data.code == 10000) {
            that.province = res.data.data;
          }
        });
    },
    getshi: function() {
      let that = this;
      that.city = [];
      that.district = [];
      // that.userMsg.City = that.address.province;
      that.province.forEach((val) => {
        if (that.address.province == val.name) {
          console.log(val);
          //that.userMsg.Province=val.code;    省份代码从公司获取
          // that.company.Province=val.code //省份代码从公司获取
          that.$axios
            .post(
              "chinaarea/index",
              that.$qs.stringify({
                level: 2,
                pcode: val.code,
              })
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 10000) {
                that.city = res.data.data;
              }
            });
        }
      });
    },
    getqu: function() {
      let that = this;
      that.district = [];
      // that.userMsg.City += that.address.city;
      that.city.forEach((val) => {
        if (that.address.city == val.name) {
          console.log(val);
          that.$axios
            .post(
              "chinaarea/index",
              that.$qs.stringify({
                level: 3,
                ccode: val.code,
              })
            )
            .then((res) => {
              console.log();
              if (res.data.code == 10000) {
                that.district = res.data.data;
              }
            });
        }
      });
    },
    getqus: function() {},
    getchild() {
      let that = this;
      this.$axios
        .post(
          "company/getchild",
          that.$qs.stringify({
            ID: 1,
            Status: 1,
          })
        )
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == 10000) {
            that.yjgs = res.data.data;
          }
        });
    },
    empty(arr) {
      let arrs = [];
      arr.forEach((val) => {
        for (let keys in val) {
          val[keys] = "";
        }
      });
      arrs = arr;
      return arrs;
    },
    getEjgs: function() {
      let that = this;
      console.log(111);
      that.ejgs = [];
      that.sjgs = [];
      that.sijgs = [];
      that.wjgs = [];
      if (!that.companyID[0].Company) {
        that.empty(that.companyID.splice(0)).map((val) => {
          that.companyID.push(val);
        });
        console.log(that.companyID);
      } else {
        that.yjgs.forEach((val) => {
          console.log(val.Rank);
          if (that.companyID[0].Company == val.ID) {
            console.log(val, 1);
            that.companyID[0].Company = val.ID;
            that.companyID[0].Rank = Number(val.Rank) + 1;
            // that.company.Rank = Number(val.Rank) + 1;
            that.companyID[0].Province = val.Province;
            console.log(that.companyID, 1111111111111);
            // that.userMsg.Company = val.ID;
            // that.company.SuperiorD = val.ID;
            // that.userMsg.Province = val.Province;
            // console.log(val.ID);
            // that.company.Province = val.Province;
            this.$axios
              .post(
                "company/getchild",
                that.$qs.stringify({
                  ID: val.ID,
                  Status: 1,
                })
              )
              .then((res) => {
                console.log(res.data.data);
                if (res.data.code == 10000) {
                  that.ejgs = res.data.data;
                }
              });
          }
        });
      }
      console.log(this.companyID);
    },
    getSjgs: function() {
      let that = this;
      that.sjgs = [];
      that.sijgs = [];
      if (!that.companyID[1].Company) {
        that.empty(that.companyID.splice(1)).map((val) => {
          that.companyID.push(val);
        });
      } else {
        that.ejgs.forEach((val) => {
          console.log(val.Rank);
          if (that.companyID[1].Company == val.ID) {
            that.companyID[1].Rank = Number(val.Rank) + 1;
            that.companyID[1].Province = val.Province;
            that.companyID[1].Company = val.ID;
            // that.company.Rank = Number(val.Rank) + 1;
            // console.log(that.company.Rank);
            // that.userMsg.Company = val.ID;
            // that.company.SuperiorD = val.ID;
            // that.userMsg.Province = val.Province;
            // console.log(val, 2);
            // that.company.Province = val.Province;
            this.$axios
              .post(
                "company/getchild",
                that.$qs.stringify({
                  ID: val.ID,
                  Status: 1,
                })
              )
              .then((res) => {
                console.log(res.data.data);
                if (res.data.code == 10000) {
                  that.sjgs = res.data.data;
                }
              });
          }
        });
      }

      console.log(this.companyID);
    },
    getSijgs: function() {
      let that = this;
      console.log("aaaa");
      that.sijgs = [];
      that.wjgs = [];
      if (!that.companyID[2].Company) {
        that.empty(that.companyID.splice(2)).map((val) => {
          // console.log(val)
          that.companyID.push(val);
        });
      } else {
        that.sjgs.forEach((val) => {
          // console.log(val.Rank)
          if (that.companyID[2].Company == val.ID) {
            that.companyID[2].Rank = Number(val.Rank) + 1;
            that.companyID[2].Province = val.Province;
            that.companyID[2].Company = val.ID;
            console.log(that.companyID);
            // that.userMsg.Rank = Number(val.Rank) + 1;
            // console.log(that.company.Rank, 3);
            // console.log(that.userMsg.Rank);
            // that.company.Rank = Number(val.Rank) + 1;
            // console.log(that.company.Rank);
            // that.userMsg.Company = val.ID;
            // that.company.SuperiorD = val.ID;
            // console.log(val.ID, "3");
            // console.log(val);
            // that.userMsg.Province = val.Province;
            // that.company.Province = val.Province;
            this.$axios
              .post(
                "company/getchild",
                that.$qs.stringify({
                  ID: val.ID,
                  Status: 1,
                })
              )
              .then((res) => {
                // console.log(res.data.data);
                if (res.data.code == 10000) {
                  that.sijgs = res.data.data;
                }
              });
          }
        });
      }
    },
    getWjgs: function() {
      let that = this;
      this.wjgs = [];
      if (!that.companyID[3].Company) {
        that.empty(that.companyID.splice(3)).map((val) => {
          // console.log(val)
          that.companyID.push(val);
        });
      } else {
        that.sijgs.forEach((val) => {
          if (that.companyID[3].Company == val.ID) {
            // that.empty(that.companyID.splice(3)).map(val => {
            //   // console.log(val)
            //   that.companyID.push(val);
            // });
            that.companyID[3].Rank = Number(val.Rank) + 1;
            that.companyID[3].Province = val.Province;
            // that.companyID[3].Company = val.ID;
            // console.log(val.Rank, 444);
            // that.userMsg.Rank = Number(val.Rank) + 1;
            // that.company.Rank = Number(val.Rank) + 1;
            // that.userMsg.Company = val.ID;
            // console.log(that.company.Rank, 4);
            // console.log(val.ID, "4");
            // that.company.SuperiorD = val.ID;
            // that.userMsg.Province = val.Province;
            // console.log(val);
            // that.company.Province = val.Province;
            this.$axios
              .post(
                "company/getchild",
                that.$qs.stringify({
                  ID: val.ID,
                  Status: 1,
                })
              )
              .then((res) => {
                console.log(res.data.data);
                if (res.data.code == 10000) {
                  that.wjgs = res.data.data;
                }
              });
          }
        });
      }
      console.log(that.companyID);
    },
    getLjgs: function() {
      let that = this;
      if (!that.companyID[4].Company) {
        for (var key in that.companyID[4]) {
          that.companyID[4][key] = "";
        }
      } else {
        that.wjgs.forEach((val) => {
          if (that.companyID[4].Company == val.ID) {
            that.companyID[4].Rank = Number(val.Rank) + 1;
            that.companyID[4].Province = val.Province;
            that.companyID[4].Company = val.ID;
            // that.userMsg.Rank = Number(val.Rank) + 1;
            // that.company.Rank = Number(val.Rank) + 1;
            // that.userMsg.Company = val.ID;
            // that.company.SuperiorD = val.ID;
            // that.userMsg.Province = val.Province;
            // console.log(val.ID);
            // that.company.Province = val.Province;
          }
        });
      }
    },
    // selCompany() {
    //   let that = this;
    //   that.$axios
    //     .post(
    //       "company/index",
    //       that.$qs.stringify({
    //         rname: this.iscompany
    //       })
    //     )
    //     .then(res => {
    //       if (res.data.code == 10000) {
    //         console.log(res.data);
    //         if (res.data.data.list.length > 0) {
    //           this.haveName = 1;
    //           let arr = res.data.data.list[0];
    //           that.company.SuperiorD = arr.ID;
    //           that.company.Rank = arr.Rank * 1 + 1;
    //         } else {
    //           this.haveName = 2;
    //         }
    //       } else {
    //         this.$message({
    //           message: res.data.msg,
    //           type: "warning"
    //         });
    //       }
    //     });
    // },
    handleSelect(item) {
      console.log(item);
    },
    changeSelect(e) {
      e.target.className = "active";
    },
    toIndex() {
      this.$router.replace("/Index");
    },
    selChange() {
      console.log(this.company.City);
      let that = this;
      that.$axios
        .post(
          "company/index",
          that.$qs.stringify({
            province: this.company.City,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data);
            this.companyList = res.data.data.list;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    getcity() {
      var that = this;
      that.$axios
        .post(
          "province/index",
          that.$qs.stringify({
            key: 1,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data);
            this.cityList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    addUser() {
      var that = this;

      that.userMsg.City =
        that.address.province + that.address.city + that.address.district;
      var arr = [];
      arr = arr.concat(that.companyID).reverse();
      console.log(arr);
      for (var i = 0, len = arr.length; i < len; i++) {
        //  console.log(that.companyID[i])
        if (arr[i].Company) {
          that.userMsg.Company = arr[i].Company;
          that.userMsg.Province = arr[i].Province;
          that.userMsg.Rank = arr[i].Rank;
          break;
        } else {
          that.userMsg.Company = "";
          that.userMsg.Province = "";
          that.userMsg.Rank = "";
        }
      }
      console.log(that.userMsg);
      // if (!that.userMsg.Company) {
      //   that.$message({
      //     message: "信息填写不完整,请重新输入",
      //     type: "warning"
      //   });
      //   console.log(1);
      //   return;
      // }
      for (let key in that.userMsg) {
        console.log(that.userMsg);
        if (that.userMsg[key] == "") {
          console.log(2, key);
          that.$message({
            message: "信息填写不完整,请重新输入",
            type: "warning",
          });
          return;
        }
        if (!(that.userMsg.Pwd === that.userMsg.Pwd1)) {
          that.$message({
            message: "两次输入密码不一致",
            type: "warning",
          });
          return;
        }
        if (that.verify) {
          that.$message({
            message: "手机格式不正确",
            type: "warning",
          });
          return;
        }
        if (that.yxgs) {
          that.$message({
            message: "邮箱格式不正确",
            type: "warning",
          });
          return;
        }
      }

      that.$axios
        .post("user/add", that.$qs.stringify(that.userMsg))
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data);
            this.$message({ message: res.data.msg, type: "success" });
          } else {
            console.log(res);
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    addCompany() {
      var that = this;
      console.log(that.company.Rank);
      var arr = [];
      arr = arr.concat(that.companyID).reverse();
      console.log(arr);
      for (var i = 0, len = arr.length; i < len; i++) {
        //  console.log(that.companyID[i])
        if (arr[i].Company) {
          that.company.SuperiorD = arr[i].Company;
          that.company.Province = arr[i].Province;
          that.company.Rank = arr[i].Rank;
          break;
        } else {
          that.company.SuperiorD = "";
          that.company.Province = "";
          that.company.Rank = "";
        }
      }
      console.log(that.company);
      if (this.xinyong) {
        that.$message({
          message: "企业统一信用代码格式不正确",
          type: "warning",
        });
        return;
      }
      console.log(that.company);
      that.company.City =
        that.address.province + that.address.city + that.address.district;
      for (let key in that.company) {
        if (!that.company[key]) {
          console.log(3, key);
          that.$message({
            message: "信息填写不完整,请重新输入",
            type: "warning",
          });
          return;
        }
      }
      if (!(that.company.Pwd === that.company.Pwd1)) {
        that.$message({
          message: "两次输入密码不一致",
          type: "warning",
        });
        return;
      }
      if (that.verify1) {
        that.$message({
          message: "手机格式不正确",
          type: "warning",
        });
        return;
      }
      if (that.yxgs1) {
        that.$message({
          message: "邮箱格式不正确",
          type: "warning",
        });
        return;
      }
      that.$axios
        .post("company/add", that.$qs.stringify(this.company))
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data, 111);
            this.$message({ message: res.data.msg, type: "success" });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    getProperty() {
      var that = this;
      that.$axios
        .post(
          "parameter/info",
          that.$qs.stringify({
            tablename: "company",
            fieldname: "Property",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data, 1);
            this.propertyList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
  },
  components: {
    Head,
    Foot,
    Login,
    RightNav,
  },
};
</script>
<style lang="less" scoped>
#Register {
  .yyzz {
    width: 11.87rem;
    height: 2.3rem;
    border: 1px solid #bdbdbd;
    margin-right: 0.2rem;

    img {
      max-width: 100%;
      max-height: 80%;
      display: block;
      margin: 0.1rem auto;
    }
  }

  .btn {
    padding: 0.1rem 0.3rem;
    background: #3694e6;
    color: white;
    border-radius: 0.05rem;
    cursor: pointer;
    margin-right: 0.2rem;
  }

  .btn2 {
    width: 2rem;
    height: 0.45rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    font-size: 0.15rem;
    border: 1px solid #ccc;
    border-radius: 0.05rem;
    margin-right: 0.2rem;
    // border: 0;
  }

  .el-radio {
    margin-bottom: 0.1rem;
  }

  .verify {
    color: red;
    margin-left: 0.1rem;
  }

  .register {
    width: 100%;
    min-width: 1000px;
    padding: 0 1.35rem;
    margin-top: 0.5rem;

    .rNav {
      width: 100%;
      display: flex;
      border-bottom: 0.01rem solid #c9c9c9;

      > div {
        border: 0.01rem solid #c9c9c9;
        border-bottom: 0;
        font-size: 0.2rem;
        padding: 0.15rem 0.3rem;
        cursor: pointer;

        &.active {
          color: white;
          background: #3694e6;
          border: 0;
        }
      }
    }

    .rMain {
      font-size: 0.2rem;
      margin-top: 0.5rem;

      > div {
        width: 9rem;
        display: flex;
        align-items: center;
        padding: 0.15rem 0;

        &.radio {
          align-items: flex-start;

          div {
            display: flex;
            font-size: 0.14rem;
            flex-wrap: wrap;
            align-items: center;

            label {
              display: flex;
              flex-shrink: 0;
              align-items: center;
              color: black;
              margin-right: 0.19rem;
              bottom: 0.05rem;

              input {
                width: 0.15rem;
                height: 0.15rem;
                margin-right: 0.05rem;
              }
            }

            span {
              margin-left: 0.1rem;
            }
          }
        }

        &.textarea {
          align-items: flex-start;

          div {
            align-items: flex-start;
            justify-content: space-between;

            textarea {
              width: 4rem;
              height: 1.5rem;
              resize: none;
              padding: 0.1rem 0.2rem;
            }

            .imgUp {
              padding: 0.1rem 0.3rem;
              background: #3694e6;
              color: white;
              border-radius: 0.05rem;
              cursor: pointer;
            }
          }
        }

        &.fBtn {
          display: flex;
          margin: 1rem auto 0;
          justify-content: space-between;

          .btn {
            width: 3.5rem;
            height: 0.6rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #d8710d;
            color: #fff;
            border-radius: 0.05rem;
            margin-bottom: 0.1rem;
          }

          .btn:nth-of-type(2) {
            background: #3694e6;
          }

          .btn1 {
            background-color: #3694e6;
          }

          .text {
            font-size: 0.14rem;
            color: #b8b8b8;

            span {
              color: #3694e6;
              cursor: pointer;
            }
          }
        }

        > span.firmSpan {
          display: inline-block;
          width: 1.3rem;
          text-align: right;
        }

        > span {
          color: #505050;
          flex-shrink: 0;
          margin-right: 0.4rem;

          span {
            display: inline-block;
            width: 0.35rem;
          }

          display: inline-block;
        }

        select,
        input {
          height: 0.4rem;
          // width: 2.5;
          margin-right: 0.2rem;
          font-size: 0.18rem;
          padding-right: 0.2rem;
        }

        input {
          padding-left: 0.2rem;
          height: 0.4rem;
          width: 5.2rem;
        }

        select {
          min-width: 2.5rem;
          // color: #757575;

          option {
            color: #000;
          }

          &.active {
            color: #000;
          }
        }

        > div {
          display: flex;
          align-items: center;
          color: red;
          position: relative;

          > .el-cascader {
            position: absolute;
            opacity: 0;
          }

          > div {
            flex-shrink: 0;
            display: flex;
            // width: 6rem;
            align-items: center;
            // margin-right: 0.1rem;

            .btn {
              width: 2rem;
              height: 0.45rem;
              // margin-left: 0.3rem;
              // border: 0.01rem solid #bdbdbd;
              display: flex;
              align-items: center;
              justify-content: center;
              // color: #b8b8b8;
              font-size: 0.15rem;
              cursor: pointer;
              border: 0;
            }
          }
        }
      }
    }
  }
}
</style>
